var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.65 24 24 18.65 24 12C24 5.34996 18.65 0 12 0C5.34996 0 0 5.34996 0 12C0 18.65 5.34996 24 12 24Z",
    fill: "#FFB208"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6.5V10H6V11.3H7.5V12.7002H6V14.0002H7.5V17.5H13C13 17.5 16.5818 17.1418 17.6823 14.0002H19V12.7002H17.9655C17.9881 12.4772 18 12.244 18 12C18 11.7561 17.9881 11.5229 17.9655 11.3H19V10H17.6823C16.582 6.8582 13 6.5 13 6.5H7.5ZM16.6554 12.7002C16.685 12.4806 16.7008 12.2474 16.7008 11.9998C16.7008 11.7524 16.685 11.5194 16.6554 11.3H8.80078V12.7002H16.6554ZM8.80078 14.0002V16.1998H12.9389C12.9389 16.1998 15.2699 15.9632 16.2621 14.0002H8.80078ZM8.80078 10H16.2624C15.2703 8.03644 12.9389 7.7998 12.9389 7.7998H8.80078V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/DAI.a7d5ac1ad51a706c5a3b20a9e82301c3.svg";
export { ForwardRef as ReactComponent };